module.exports = __webpack_public_path__ + "img/features-img1.3efb8282.png";